import GeoJSON from 'ol/format/GeoJSON';
import OLMap from 'ol/Map';
import OLVectorLayer from 'ol/layer/Vector';
import OLVectorSource from 'ol/source/Vector';
import { makeObservable, observable, reaction, when } from 'mobx';
import { RecordCard } from '@project/store/shared/RecordCard';
import { setStyle } from '@datum-group/datum-map/lib/Layer/StyleUtils/styleParsing';
import { INIT_MAP_DATA } from '@project/store';

/*
ToDo: в дальнейшем, думаю, целесообразнее получать этот слой
посредством фильтрации векторного слоя по идентификатору
что-то вроде
store.map.layerCollection.add('administration', {'id': 10})
Необходимо по-другому реализовать фильтрацию в datum-map
*/

export class RecordLayer {
  @observable card: RecordCard;
  @observable map: OLMap;
  private _layer: OLVectorLayer;

  constructor(card: RecordCard, map: OLMap) {
    this.card = card;
    this.map = map;
    this._layer = new OLVectorLayer();
    this._createLayer();

    this._layer.setMap(this.map);

    makeObservable(this);
  }

  private _createLayer = () => {
    reaction(
      () => this.card.record.record,
      () => {
        if (typeof this.card.record.record === 'undefined') return;

        const vectorSource = new OLVectorSource({
          features: new GeoJSON().readFeatures(this.card.record.record, {
            dataProjection: 'EPSG:4326',
            featureProjection: INIT_MAP_DATA.srid,
          }),
        });

        this._layer.setSource(vectorSource);

        const extent = vectorSource.getExtent();

        if (!extent) return;

        this.map.getView().fit(extent, {
          padding: [30, 30, 30, 30],
          minResolution: 1,
        });

        when(
          () => typeof this.card.connectedLayer.layer !== 'undefined',
          () => {
            // @ts-ignore
            setStyle(this._layer, this.card.connectedLayer.layer.style, map);
          },
        );
      },
    );

    return new OLVectorLayer({});
  };
}
